import { Container } from "react-bootstrap";

export default function Footer() {
  return (
    <footer className="footer-glass mt-auto">
      <Container fluid className="px-3 px-md-4 d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
        <small className="text-muted">
          © {new Date().getFullYear()} <span className="fw-semibold">Silver Star Parts</span>
        </small>
        <nav className="d-flex gap-3">
          <button type="button" className="btn btn-link p-0 text-muted me-3">Privacy</button>
          <button type="button" className="btn btn-link p-0 text-muted">Terms</button>
        </nav>
      </Container>
    </footer>
  );
}
